export const purgeStore = () => {
  return {
    type: 'PURGE_REDUX',
  };
};
